import { render } from "./color.vue?vue&type=template&id=53a2e3c7&scoped=true"
import script from "./color.vue?vue&type=script&lang=js"
export * from "./color.vue?vue&type=script&lang=js"

import "./color.vue?vue&type=style&index=0&id=53a2e3c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a2e3c7"]])

export default __exports__